__turbopack_context__.v({
  "className": "inter_e25f9e28-module__UTfzfa__className",
});
